
import {defineComponent} from "vue";
import ModalDialog from "../ob1/ModalDialog.vue";

export default defineComponent({
    name: "EditoPopin",
    props: {
        popinId: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        visual: {
            type: Object,
            required: false,
            default: null
        },
        sections: {
            type: Array,
            required: true
        },
        mentions: {
            type: String,
            required: false,
            default: ""
        }
    },
    components: {ModalDialog},
});
